module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('shared-product-edit', {
    attrs: {
      "product": _vm.product,
      "images": _vm.images
    }
  }, [_c('div', {
    staticClass: "l-col-4@md",
    attrs: {
      "slot": "attributes"
    },
    slot: "attributes"
  }, [_c('div', {
    staticClass: "margin"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('color.label')))]), _vm._v("\n      " + _vm._s(_vm.product.color) + "\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f5e3f9c2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/colombo/ProductEdit.vue
// module id = 3495
// module chunks = 0